 (function ( $ ) {
	$.fn.menuMultilevel = function(options) {
		return this.each(function() {

		 	var $container,
		 		$categoryTitle;
		 	var defaultSettings={
				listSelector: "li a",
				redirect: true,
				selector: this,
				toogleNeighbours:true
			}
		 	var settings = $.extend(true,defaultSettings, options);
		 		
		 	$(this).addClass("menuMultilevel");
		 	function setElements() {
		 		$container = $(settings.selector);
		 		$categoryTitle = $(settings.listSelector, $container);
		 	}
		 	function setEvents() { 
		 		$container.on("click", settings.listSelector, function(e) {
		 			toggleTree(e, this);
		 		});
		 	}
		 	function redirect(that) {
	 			var url = $(that).attr("href");
	 			document.location.href=url;
		 	}
		 	function toggleTree(e, that) {
		 		e.preventDefault();
		 		if(settings.redirect && !$(that).next("ul").length) {
		 			redirect(that);
		 			return;
		 		}
		 		var targetParent = $(that).parent();
		 		var farthestParents = $(that).parents(".child-active");
		 		if(settings.toogleNeighbours){
		 			$categoryTitle.parent().not(targetParent).not(farthestParents).removeClass("child-active");
		 		}
		 		targetParent.toggleClass("child-active");
		 	}
			function init() {
				setElements();
				setEvents();
			}
			init();
		});
	}
}(jQuery));